import { render, staticRenderFns } from "./MultiviewPage.vue?vue&type=template&id=e1d5b1c0&scoped=true&"
import script from "./MultiviewPage.vue?vue&type=script&lang=js&"
export * from "./MultiviewPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1d5b1c0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ganttpro/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e1d5b1c0')) {
      api.createRecord('e1d5b1c0', component.options)
    } else {
      api.reload('e1d5b1c0', component.options)
    }
    module.hot.accept("./MultiviewPage.vue?vue&type=template&id=e1d5b1c0&scoped=true&", function () {
      api.rerender('e1d5b1c0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/views/main/MultiviewPage.vue"
export default component.exports